

class UIProp 
{

   constructor(name, val){
    this.name = name;
    this.val = val;
   }


 /*
  *
  *
  */ 
   updateVal(newVal){
    this.val = newVal;
    $(document).trigger('UIPropChanged', [this.name, this.val]);
   }

}


export default class UIProps 
{



 constructor(props, isClass = false){
   if(!isClass){
    this.props = [];
    this.setProps(props);
    this.registerDocumentTrigger();
   } else {
     this.classProps = {};
     this.classPropsAlias = [];
   }
 }
  


  
 /*
  *
  *
  */ 
 bindClassPropsToUI(_class, hasPrefix = true) {

  const prefix = this.bindClassHelpers().lowercaseFirstLetter(_class.constructor.name);
  let classMethods = Object.getPrototypeOf(_class);

  //loop thru props
  for(var key in _class){
    if(this.bindClassHelpers().canAddClassProp(_class, key)){
      var _key = (hasPrefix ? prefix + this.bindClassHelpers().capitalizeFirstLetter(key) : key);
      this.classProps = Object.assign(this.classProps, { [_key]: _class[key]});
      this.classPropsAlias.push(this.bindClassHelpers().generatePropAlias(key, _key, 'property'));
    }
  }

  //loop thru methods
  for(var classMethodName in classMethods) {
    if(this.bindClassHelpers().canAddClassMethod(_class, classMethods, classMethodName)) {
       var _classMethodName = (hasPrefix ? prefix + this.bindClassHelpers().capitalizeFirstLetter(classMethodName) : classMethodName );
       this.classProps = Object.assign(this.classProps, {[_classMethodName] : _class[classMethodName]() });
       this.classPropsAlias.push(this.bindClassHelpers().generatePropAlias(classMethodName, _classMethodName, 'method'));
    }
  }


  return this.classProps;

 }



 //TODO: register an event that triggers whenever a class method (that is part of the ui prop obj) is called 
 //TODO: register an event that triggers whenever a class property (that is part of the ui prop obj) changes 

 /*
  *
  *
  */ 
 bindClassHelpers() {
  var _this = this;

  var helpers = {

     getArgs: (func) => {
      // First match everything inside the function argument parens.
      var args = func.toString().match(/function\s.*?\(([^)]*)\)/)[1];
     
      // Split the arguments string into an array comma delimited.
      return args.split(',').map(function(arg) {
        // Ensure no inline comments are parsed and trim the whitespace.
        return arg.replace(/\/\*.*\*\//, '').trim();
      }).filter(function(arg) {
        // Ensure no undefined values are added.
        return arg;
      });
    },

    getArgsCount: (func) => {
      return helpers.getArgs(func).length;
    },

    classMethodHasArgs: (func) => {
      return helpers.getArgsCount(func) > 0;
    },

    capitalizeFirstLetter: (str) => {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    lowercaseFirstLetter: (str) => {
      return str.charAt(0).toLowerCase() + str.slice(1);
    },

    isValidProp: (prop) => {
      return typeof prop === "number" || typeof prop === "string"
    },

    isInvalidProp: (prop) => {
      return typeof prop === "object"
    },

    canAddClassMethod: (_class, classMethods, classMethodName) => {
      return classMethods.hasOwnProperty(classMethodName)
       && !helpers.classMethodHasArgs(_class[classMethodName])
       && classMethodName !== "bindClassPropsToUI"
       && !helpers.isInvalidProp(_class[classMethodName]());
    },

    canAddClassProp: (_class, key) => {
      return _class.hasOwnProperty(key) && !helpers.isInvalidProp(_class[key]);
    },

    generatePropAlias: (name, uiPropName, type) => {
      return {
        name: name,
        uiPropName: uiPropName,
        type: type,
      };
    },
    onChange: (changeable, action) => {
      return _this.onChange(changeable, () => {
        action(changeable);
      })
    },

  };

  return helpers;

 }



 /*
  *
  *
  */ 
 onChange(object, onChange){
  const handler = {
    get(target, property, receiver) {
      try {
        return new Proxy(target[property], handler);
      } catch (err) {
        return Reflect.get(target, property, receiver);
      }
    },
    defineProperty(target, property, descriptor) {
      onChange();
      return Reflect.defineProperty(target, property, descriptor);
    },
    deleteProperty(target, property) {
      onChange();
      return Reflect.deleteProperty(target, property);
    },
  };
  return new Proxy(object, handler);  
 }



 /*
  *
  *
  */ 
 bindPropsToUI(){
   return this.props.map(prop => {
     this.updateView(prop);
   }) || false;
 }
  
 /*
  *
  *
  */ 
 setProps(props) {
  for(var key in props) {
    if(props.hasOwnProperty(key)) {
       this.props.push(new UIProp(key, props[key]));
    }
   }
   this.bindPropsToUI();
 }
  


  
 /*
  *
  *
  */ 
 registerDocumentTrigger() {
    var ins = this;
    $(document).on( 'UIPropChanged' , function(e, name, val) { 
      ins.updateClassAndUI(name, val);
    });      
 }
  

 /*
  *
  *
  */ 
 update(name, val) {
   return this.props.map(prop => {
     prop.name == name ? prop.updateVal(val) : '';
   }) || false;
 }
  
 /*
  *
  *
  */ 
 mapProps(action, mapType = 'array') {
  
  var map;
  
  if(mapType == 'array'){
   map = [];
  }
  
  this.props.map(prop => {
   action(prop, map)
  });

  return map;
 }
  

 /*
  *
  *
  */ 
 get(propName, valOnly = true) { 
   var propVal;
   this.props.map(prop => {
     if(prop.name === propName) {
       if(valOnly === true) {
         propVal = prop.val;
       } else {
         propVal = prop;
       }
     }
   });
   return propVal;
 }

  
 /*
  *
  *
  */ 
 updateClassAndUI(name, val) {
   for(var i = 0; i < this.props.length; i++){
     if(this.props[i].name == name ){
       this.props[i].val = val;
       this.updateView(this.props[i]);
      }
   }
  }
  


 /*
  *
  *
  */ 
  updateView(prop) {
    $("#" + prop.name).html(prop.val);
  }


}


// WEBPACK FOOTER //
// ./scripts/classes/uiprops.js